module Client.Components.InputHelper

open Fable.React.Props
open Fable.React
open Shared.Infrastructure

let onBlurOptionalString (f: string option -> unit) =
    OnBlur(fun event -> event.Value |> String.toOption |> f)